import { useAnimations, ContactShadows } from "@react-three/drei";
import { useDracoGLTF } from "../../../../utils/useDracoGLTF";
import { useMemo, Suspense, useEffect, useState, useRef } from "react";

import { cameraStore, store } from "../../../../appStore";
import { ref } from "valtio";
import LoadingCallback from "../../../LoadingCallback";

import { Route, Router, Switch, useLocation, useRoute } from "wouter";
import useLevel from "../../../../hooks/useLevel";

import { useTranslation } from "react-i18next";

import { LoopOnce, LoopRepeat } from "three";

import * as THREE from "three";

import { findAllObjectsStartsWithKey, findChildStartsWithKey, findObjectStartsWithKey } from "../../../../utils/FindObjects";
import Hotspot from "../../../ui/Hotspot";
import useHashLocation from "../../../../use-hash-location";

import useAuth from "../../../../hooks/useAuth";
import { getUrl } from "../../../../utils";

import { Ebbne, MountWithEbbne, useEbbne, useEbbnenContext } from "@solidwhite/ebbnen";

import RotaryTableAnimation from "./RotaryTableAnimation";
import fragmentShaderReplacement from "../../shader/VertexColorHeat_replacement.glsl";
import fragmentShaderAddition from "../../shader/VertexColorHeat_addition.glsl";
import VerticalAnimation from "./verticalanimation/VerticalAnimation";
import ControlPanel from "./ControlPanel/ControlPanel";
import AnimationToggle from "./ergonomy/AnimationToggle";
import MachineSize from "./modular/MachineSize";
import Recooling from "./modular/Recooling";
import MainSpindleTubes from "./MainSpindleTubes";
import { SideBarHider } from "../../../ui/SideBar/SideBar";

export const HardlineWrapper = ({ ...props }) => {
  const [model, setModel] = useState();
  const [fullAccess, setfullAccess] = useState(false);

  const { currentUser } = useAuth();

  useEffect(() => {
    if (currentUser !== null) {
      getUrl({
        // new aws-amplify v6 getUrl needs public but data directory doesnt reflect that
        path: `${import.meta.env.MODE === "electron" ? "" : "public/"}authenticated/models/Hardline.glb`,
      })
        .then((result) => {
          console.log("Secret Hardline loaded", result);
          setModel(result.url.toString());
          setfullAccess(true);
        })
        .catch((err) => {
          console.log(err);
        });
      cameraStore.minPolarAngle = 0;
      cameraStore.maxPolarAngle = 180;
      cameraStore.zoomEnabled = true;
      cameraStore.zoomEnabled = true;
    } else {
      setModel(null);
      setfullAccess(false);
      cameraStore.minPolarAngle = 75;
      cameraStore.maxPolarAngle = 105;
      cameraStore.zoomEnabled = false;
      cameraStore.translationEnabled = false;
    }
    return () => {
      cameraStore.minPolarAngle = 0;
      cameraStore.maxPolarAngle = 180;
      cameraStore.translationEnabled = true;
      cameraStore.zoomEnabled = true;
    };
  }, [currentUser]);

  if (fullAccess)
    return (
      <group>
        <Suspense fallback={<LoadingCallback />}>
          <Hardline model={model} fullAccess={true} key="Hardline_private" />
          {/* <Hardline
          model={"./models/heat/Hardline.glb"}
          fullAccess={true}
          key="Hardline_private"
        /> */}
        </Suspense>
        <Floor />
      </group>
    );
  else
    return (
      <group>
        <Suspense fallback={<LoadingCallback />}>
          <Hardline model={"./models/heat/Hardline.glb"} fullAccess={false} key="Hardline_public" />
        </Suspense>
        <Floor />
      </group>
    );
  // else return null;
};

const Floor = () => {
  return (
    <mesh rotation={[THREE.MathUtils.degToRad(-90), 0, 0]} position={[4.756, 0, -6.236]} layers={[1]} visible={false}>
      <planeGeometry args={[20, 20]} />
      <meshNormalMaterial transparent depthTest={false} />
    </mesh>
  );
};

const Hardline = ({ model, fullAccess = false, ...props }) => {
  const { active } = useEbbne();
  const { locationHook, currentId } = useEbbnenContext();

  const [location, setLocation] = locationHook();
  const [hardlineLocation, setHardlineLocation] = useState("");

  // const [currentLevel, currentRouteId, parentRouteId] = useLevel();
  const { nodes, scene, animations } = useDracoGLTF(model);

  const { actions } = useAnimations(animations, scene);

  const { t } = useTranslation();

  useEffect(() => {
    Object.values(actions).forEach((action) => {
      action.loop = LoopRepeat;
      action.clampWhenFinished = false;
    });
  }, [actions]);

  const SubSections = useMemo(() => {
    const subSections = {};
    var firstLvlSubSection = findChildStartsWithKey("SubSection", nodes.Hardline_1);

    firstLvlSubSection.children.forEach((c) => {
      subSections[`/hardline/${c.name}`] = c;
    });

    Object.values(subSections).forEach((ss) => {
      var subSubSections = [];
      var secondLvlSubSections = findChildStartsWithKey("SubSection", ss);
      if (secondLvlSubSections) {
        secondLvlSubSections.children.forEach((c) => {
          subSections[`/hardline/${ss.name}/${c.name}`] = c;
          subSubSections.push(c);
        });
      }

      subSubSections.forEach((sss) => {
        var thirdLvlSubSections = findChildStartsWithKey("SubSection", sss);
        if (thirdLvlSubSections) {
          thirdLvlSubSections.children.forEach((c) => {
            subSections[`/hardline/${ss.name}/${sss.name}/${c.name}`] = c;
          });
        }
      });
    });

    return subSections;
  }, [nodes]);

  const cameraTargets = useMemo(() => {
    var obj = findObjectStartsWithKey("CameraTargets_All", scene);
    var camTargets = {};
    obj.children.forEach((c) => {
      if (c.userData.route) camTargets[c.userData.route] = c;
    });

    return camTargets;
  });

  const hotSpots = useMemo(() => {
    var hotspots = [];
    var hsParent;
    if (hardlineLocation == "/hardline") {
      hsParent = findObjectStartsWithKey("Labels_Root", scene);
    } else {
      hsParent = findChildStartsWithKey("Label", SubSections[hardlineLocation]);
    }
    if (hsParent) {
      hsParent.children.forEach((c) => hotspots.push(c));
    }

    return hotspots;
  }, [hardlineLocation]);

  useEffect(() => {
    var route = location.split("/hardline");
    route = location.replace(route[0], "");
    setHardlineLocation(route);
  }, [location]);

  useEffect(() => {
    document.body.style.cursor = "auto";
  }, []);

  useEffect(() => {
    if (cameraTargets[hardlineLocation]) {
      cameraStore.cameraTargetSettings = ref(cameraTargets[hardlineLocation]);
    } else {
      cameraStore.cameraTargetSettings = ref(cameraTargets["/hardline"]);
    }
  }, [hardlineLocation]);

  const handleLabelClick = (e, hotspot) => {
    e.stopPropagation();
    setLocation(`${location}/${hotspot.userData.targetId}`);
  };

  //Material fixes for TellerAnimation
  useEffect(() => {
    var tellers = findAllObjectsStartsWithKey("Hardline_Teller_Werkstueck_01", scene);

    tellers.forEach((teller1) => {
      var materialClone = teller1.material.clone();
      materialClone.uniforms = {
        uHeat: {
          value: 0.0,
        },
        uHeatFallof: {
          value: 0.9,
        },
        ...materialClone.uniforms,
      };

      materialClone.onBeforeCompile = (s) => {
        s.uniforms.uHeat = {
          value: 0.0,
        };
        s.uniforms.uHeatFallof = {
          value: 0.9,
        };
        s.uniforms.uHardened = {
          value: teller1.name.startsWith("Hardline_Teller_Werkstueck_01_baked") ? 1.0 : 0.0,
        };
        s.fragmentShader = `${fragmentShaderAddition}\n${s.fragmentShader}`;
        s.fragmentShader = s.fragmentShader.replace(`#include <color_fragment>`, ``);
        s.fragmentShader = s.fragmentShader.replace(`#include <dithering_fragment>`, fragmentShaderReplacement);

        materialClone.userData.shader = s;
      };

      teller1.material = materialClone;
    });
  }, []);

  //Hide some stuff
  useEffect(() => {
    const sizes = findObjectStartsWithKey("EFD_HL_Maschine_size", scene);
    sizes.visible = false;

    const cooling = findObjectStartsWithKey("EFD_Hardline_recooling", scene);
    cooling.visible = false;
  }, []);

  return (
    <group>
      <primitive object={scene} />
      <ContactShadows
        opacity={1}
        scale={50}
        blur={1}
        far={10}
        resolution={256}
        color="#000000"
        position={[0, -0.01, 0]}
        frames={10}
      />
      <group position={nodes.Hardline_1.position} rotation={nodes.Hardline_1.rotation}>
        {hotSpots.map((hotspot, idx) => (
          <Hotspot
            position={hotspot.position}
            text={hotspot.userData.textId ? t(hotspot.userData.textId) : hotspot.name.toUpperCase()}
            topLeft
            onClick={(e) => handleLabelClick(e, hotspot)}
            delay={20 + 300 * idx}
            id={hotspot.name}
            key={hotspot.name}
            isAnimation={hotspot.userData.isAnimation}
          />
        ))}

        {fullAccess && (
          <>
            {/* <AnimationsSwitch object3d={scene} actions={actions} /> */}
            <SubEbbnen object3d={scene} actions={actions} />

            {currentId != "rotarytable" && <MainSpindleTubes object3d={scene} />}
          </>
        )}
      </group>
    </group>
  );
};

const SubEbbnen = ({ object3d, actions, ...props }) => {
  return (
    <>
      <Ebbne id="process">
        <MountWithEbbne>
          <SideBarHider />
        </MountWithEbbne>

        <Ebbne id="rotarytable">
          <MountWithEbbne>
            <RotaryTableAnimation object3d={object3d} action={actions["Anim_HL_TellerProcess"]} />
          </MountWithEbbne>
        </Ebbne>

        <Ebbne id="vertical">
          <MountWithEbbne>
            <VerticalAnimation object3d={object3d} action={actions["Anim_HL_RinginductorProcess"]} />
          </MountWithEbbne>
        </Ebbne>
      </Ebbne>

      <Ebbne id="control">
        <MountWithEbbne>
          <ControlPanel object3d={object3d} />
        </MountWithEbbne>
      </Ebbne>

      <Ergonomy object3d={object3d} actions={actions} />
      <Modularity object3d={object3d} actions={actions} />
    </>
  );
};

const Ergonomy = ({ object3d, actions }) => {
  return (
    <Ebbne id="ergonomy">
      <MountWithEbbne>
        <SideBarHider />
      </MountWithEbbne>

      <Ebbne id="sideflap">
        <MountWithEbbne>
          <AnimationToggle action={actions["Anim_HL_sidedoor"]} />
        </MountWithEbbne>
      </Ebbne>

      <Ebbne id="frontflap">
        <MountWithEbbne>
          <AnimationToggle action={actions["Anim_HL_frontvalve"]} />
        </MountWithEbbne>
      </Ebbne>

      <Ebbne id="maintenance">
        <MountWithEbbne>
          <AnimationToggle action={actions["Anim_HL_Backdoor"]} />
        </MountWithEbbne>
      </Ebbne>

      <Ebbne id="liquid">
        <MountWithEbbne>
          <AnimationToggle action={actions["Anim_HL_watervalve"]} delay={750} />
        </MountWithEbbne>
      </Ebbne>

      <Ebbne id="frontdoor">
        <MountWithEbbne>
          <AnimationToggle action={actions["Anim_HL_Frontdoor"]} delay={750} />
        </MountWithEbbne>
      </Ebbne>
    </Ebbne>
  );
};

const Modularity = ({ object3d, actions }) => {
  return (
    <Ebbne id="modular">
      <MountWithEbbne>
        <SideBarHider />
      </MountWithEbbne>

      <Ebbne id="size">
        <MountWithEbbne>
          <MachineSize object3d={object3d} />
          <AnimationToggle action={actions["Anim_HL_Showbuildingroom"]} delay={0} />
        </MountWithEbbne>
      </Ebbne>

      <Ebbne id="periphery">
        <MountWithEbbne>
          <Recooling object3d={object3d} />
        </MountWithEbbne>
      </Ebbne>

      <Ebbne id="rotary">
        <MountWithEbbne>
          <AnimationToggle action={actions["Anim_HL_Showspindle"]} delay={0} />
        </MountWithEbbne>
      </Ebbne>

      <Ebbne id="converter">
        <MountWithEbbne>
          <AnimationToggle action={actions["Anim_HL_umrichter"]} delay={500} />
        </MountWithEbbne>
      </Ebbne>

      <Ebbne id="spindle">
        <MountWithEbbne>
          <AnimationToggle action={actions["Anim_HL_AxesDemonstation"]} delay={0} timeScale={0} />
        </MountWithEbbne>
      </Ebbne>

      <Ebbne id="axles">
        <MountWithEbbne>
          <AnimationToggle action={actions["Anim_HL_AxesDemonstation"]} delay={0} />
        </MountWithEbbne>
      </Ebbne>
    </Ebbne>
  );
};

export default Hardline;
